import { render, staticRenderFns } from "./DonateExtraTile.vue?vue&type=template&id=22c7d8d3&"
import script from "./DonateExtraTile.vue?vue&type=script&lang=js&"
export * from "./DonateExtraTile.vue?vue&type=script&lang=js&"
import style0 from "./DonateExtraTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports